import { PartyDto } from '../models/sent-email-info'
import MessageArgs, { defaultMessageArgs } from './message-args'
import broadcastMessageToPortals from './broadcast-message-to-portals'

export interface EmailPostSentArgs extends MessageArgs {
  threadId: string
  threadIndex: string
  id: string
  legacyThreadIndex?: string
  legacyThreadId?: string
  headerMessageId?: string
  timestamp: number
  trackingId?: string
  replyTrackingId?: string
  subject: string
  sentBy: PartyDto
  toRecipients: PartyDto[]
  ccRecipients: PartyDto[]
  bccRecipients: PartyDto[]
}

export interface EmailPostSentParams {
  id: string
  threadId: string
  threadIndex: string
  headerMessageId: string
  timestamp: Date
  trackingId?: string
  replyTrackingId?: string
  subject: string
  sentBy: PartyDto
  toRecipients: PartyDto[]
  ccRecipients: PartyDto[]
  bccRecipients: PartyDto[]
}

export default function emailPostSentMessage(params: EmailPostSentParams) {
  const args: EmailPostSentArgs = {
    ...defaultMessageArgs(),
    threadId: params.threadId,
    threadIndex: params.threadIndex,
    id: params.id,
    headerMessageId: params.headerMessageId,
    timestamp: +params.timestamp,
    trackingId: params.trackingId,
    replyTrackingId: params.replyTrackingId,
    subject: params.subject,
    sentBy: params.sentBy,
    toRecipients: params.toRecipients,
    ccRecipients: params.ccRecipients,
    bccRecipients: params.bccRecipients,
  }

  broadcastMessageToPortals('EmailPostSent', args)
}
